module.exports = __webpack_public_path__ + "media/tutorial-v1.bd5b45d4.mp4";